import { getField, updateField } from "vuex-map-fields";

import _ from "lodash";

let defaultState = () => {
  return {
    selectedCurrencyId: null,

    lineItems: [],

    discount: {
      id: null,
      rate: null,
      percentage: false
    },

    discountEnabled: false
  };
};

export default {
  namespaced: true,

  state: defaultState(),

  getters: {
    getField,

    selectedCurrency (state, _getters, rootState) {
      return rootState.instruments.currencies.find(c => c.id === state.selectedCurrencyId);
    },

    nonRemovedLineItems (state) {
      return state.lineItems.filter(li => !li.removed);
    },

    discountAmount (state, getters) {
      if (state.discountEnabled === false) { return 0; }

      return state.discount.percentage
        ? getters.subtotalAmount * (state.discount.rate || 0) / 100
        : (state.discount.rate || 0);
    },

    subtotalAmount (state, getters) {
      return getters.nonRemovedLineItems.reduce((result, lineItem) => result + lineItem.amount, 0);
    },

    totalAmount (state, getters) {
      return getters.nonRemovedLineItems.reduce(
        (result, lineItem) => result + lineItem.totalAmount, 0);
    },

    isOneLineItemLeft (state, getters) {
      return getters.nonRemovedLineItems.length === 1;
    },

    isOneEmptyLineItemLeft (state, getters) {
      if (getters.nonRemovedLineItems.length === 1) {
        return isLineItemEmpty(getters.nonRemovedLineItems[0]);
      }

      return false;
    },

    summaryTaxes (state, getters, rootState) {
      let taxIds = _.without(_.uniq(_.map(getters.nonRemovedLineItems, "tax_id")), "");

      let result = rootState.instruments.taxes.filter(
        tax => taxIds.includes(tax.id) && taxAmount(state, getters, tax) > 0
      ).map(
        tax => ({ ...tax, amount: taxAmount(state, getters, tax) })
      );

      return result;
    },

    showTaxesDropdown (state, getters, rootState) {
      return rootState.instruments.taxes.length > 1;
    }
  },

  mutations: {
    updateField,

    addLineItem (state, lineItem) {
      state.lineItems.push(lineItem);
    },

    removeLineItem (state, index) {
      state.lineItems[index].removed = true;

      state.lineItems = [...state.lineItems];
    },

    removeEmptyLineItems (state) {
      if (state.lineItems.length === 1) {
        return;
      }

      state.lineItems = state.lineItems.filter(
        lineItem => lineItem.name !== null || lineItem.quantity > 1 || lineItem.price !== null
      );

      if (state.lineItems.length === 0) {
        this.commit("addLineItem");
      }
    },

    resetState (state) {
      Object.assign(state, defaultState());
    },

    updateDiscount (state, discount) {
      if (discount) {
        state.discount = discount;
        state.discountEnabled = true;
      }
    }
  },

  actions: {
    addNewLineItem ({ commit, state, rootState }) {
      let newLineItem = {
        name: null,
        quantity: 1,
        price: null,
        tax_id: rootState.instruments.taxes[0].id,
        tax: rootState.instruments.taxes[0],
        amount: 0,
        currency: rootState.instruments.currencies[0],
        totalAmount: 0,
        removed: false
      };

      rootState.instruments.taxes.forEach(t => {
        newLineItem[`tax_${t.id}_amount`] = 0;
      });

      commit("addLineItem", newLineItem);
    },

    updateLineItems ({ commit, state, rootState }, lineItems) {
      lineItems.forEach((li) => {
        let r = {
          ...li,
          removed: false,
          totalAmount: li.total_amount
        };

        rootState.instruments.taxes.forEach(t => {
          r[`tax_${t.id}_amount`] = 0;
        });

        r[`tax_${li.tax_id}_amount`] = li.tax_amount
          ? li.tax_amount : li[`tax_${li.tax_id}_amount`];

        commit("addLineItem", r);
      });
    }
  }
};

// Helpers

function isLineItemEmpty (lineItem) {
  return lineItem.name === null && lineItem.quantity === 1 && lineItem.price === null;
}

function taxAmount (state, getters, tax) {
  let result = getters.nonRemovedLineItems.reduce(
    (result, lineItem) => result + (lineItem[`tax_${tax.id}_amount`] || 0),
    0
  );

  return result;
}
